import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { cdnUrlConfig } from '../../../Utils/atoms';

const PrizePopUp = (props) => {
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;
	const [rewardName, setRewardName] = useState('[]');
	const [price, setPrice] = useState('');
	// 확인버튼 클릭
	const ClickSave = () => {
		// 닫기
		props.close();
	};

	useEffect(() => {
		switch (props.rewardResult.rank_no) {
			case 1:
				setRewardName('올리브영 기프트카드');
				setPrice('50,000원 권');
				break;
			case 2:
				setRewardName('CU 모바일 금액권');
				setPrice('5,000원 권');
				break;
			case 3:
				setRewardName('다이소 모바일 금액권');
				setPrice('3,000원 권');
				break;
			case 4:
				setRewardName('하트');
				setPrice('15개');
				break;
			case 5:
				setRewardName('젤리');
				setPrice('600개');
				break;
			case 6:
				setRewardName('젤리');
				setPrice('300개');
				break;
			}

	}, []);

	return (
		<>
			{/* 당첨 됐을 경우 표출 되는 팝업(기프티콘 카드, 재화 모두 사용) */}
			<div className='dim'></div>
			<div className='popup pop-giveaway'>
				<header>
					<h1>
						<span>
							당첨을
							<span>축하합니다!</span>
						</span>
					</h1>
				</header>
				<div className='content'>
					<div className='product'>
						<div className='photo'> {/** 기프티콘 카드와 재화 모두 사용 */}
							<img
								src={`${IMG_URL}/images/roulette/product_${props.rewardResult.rank_no}.png`}
								alt=''
							/>
						</div>
						<dl>
							<dt>{rewardName}</dt>
							<dd>{price}</dd>
						</dl>
					</div>
				</div>
				<div className='btn-area'>
					<button className='btn-confirm' onClick={ClickSave}>
						확인
					</button>
				</div>
			</div>
		</>
	);
};

export default PrizePopUp;
